import { useEffect, useState } from 'react';

import Button from '@mui/material/Button';

import Loading from 'uI/Loading/Loading';
import Message from 'uI/Message/Message';
import MetadataByCampus from './MetadataByCampus/MetadataByCampus';

import {
  getUserMetadata,
  saveNewMetaData
} from 'store/myAccount-actions';

import classes from './Metadata.module.css';

const Metadata = () => {
  const [openMessage, setOpenMessage] = useState(false);
  const [load, setLoad] = useState(true);
  const [loadNewData, setLoadNewData] = useState(false);
  const [saveBtn, setSaveBtn] = useState(false);
  const [userMetadata, setUserMetadata] = useState([]);
  const [campus, setCampus] = useState([]);
  const [newMetadata, setNewMetadata] = useState([]);

  useEffect(() => {
    (async () => {
      setUserMetadata(await getUserMetadata());
      setLoad(false);
    })();
  }, []);

  useEffect(() => {
    const academies = [];
    userMetadata.map(metadata => {
      academies.push(metadata.academies);
      const uniqueAcademies = [];
      academies.forEach(item => {
        if (!uniqueAcademies.includes(item)) {
          uniqueAcademies.push(item);
        }
      });
      setCampus(uniqueAcademies);
    });
  }, [userMetadata]);

  const saveDataHandler = () => {
    setLoadNewData(true);
    let editMetaDataObject = [];
    userMetadata.map(data => {
      let sendData = {};
      sendData.tag = data.tag;
      const addEdit = newMetadata.find(
        newData => newData.tag === data.tag
      );
      if (addEdit) {
        sendData.tagValue = addEdit.value;
      } else {
        sendData.tagValue = data.preloadData;
      }
      editMetaDataObject.push(sendData);
    });
    (async () => {
      const save = await saveNewMetaData(editMetaDataObject);
      setLoadNewData(false);
      setSaveBtn(false);
      if (save) {
        setOpenMessage(true);
      }
    })();
  };

  const newMetadataHandler = (tag, value) => {
    setSaveBtn(true);
    setNewMetadata([...newMetadata, { tag, value }]);
  };

  const closeDialogHandler = () => {
    setOpenMessage(false);
  };

  return (
    <>
      {!load ? (
        <>
          <aside className={classes.descriptionSection}>
            <p className={classes.title}>Información Adicional</p>
          </aside>
          <div className={classes.metadataContainer}>
            {campus.map(campus => (
              <MetadataByCampus
                key={campus}
                campus={campus}
                userMetadata={userMetadata}
                newMetadataHandler={newMetadataHandler}
              />
            ))}
            <div className={classes.btnContainer}>
              {!loadNewData ? (
                <Button
                  className={classes.saveChangesBtn}
                  disabled={!saveBtn}
                  onClick={saveDataHandler}
                >
                  Guardar cambios
                </Button>
              ) : (
                <Loading />
              )}
            </div>
          </div>
        </>
      ) : (
        <Loading />
      )}
      {openMessage && (
        <Message
          openDialog={openMessage}
          message="Los cambios fueron guardados con éxito"
          closeDialog={closeDialogHandler}
          btnText="De acuerdo"
        />
      )}
    </>
  );
};

export default Metadata;
